import { Typography } from '@mui/material';

const extractColumnsFromFirstRow = (data) => {
  if (!Array.isArray(data) || data.length === 0) return [];

  const properties = data[0];
  const columns = [];

  Object.entries(properties).forEach(([propName, propType]) => {
    columns.push({
      propertyName: propName,
      valueType: propType
    });
  });

  return columns;
};

export const assetsGridColumnGenerator = (defaultVisibleFields, data, renderCell, renderEditCell) => {
  const columnMeta = extractColumnsFromFirstRow(data);
  const hasNameColumn = columnMeta?.some(col => col?.propertyName?.toLowerCase() === 'name');
  const nameColumn = hasNameColumn ? columnMeta?.find(col => col?.propertyName?.toLowerCase() === 'name') : null;

  const sortableColumns = columnMeta
    .filter(col => col.propertyName !== 'name')
    .sort((a, b) =>
      a.propertyName.localeCompare(b.propertyName, undefined, {
        sensitivity: 'base',
      })
    );

  const finalColumnMeta = hasNameColumn ? [nameColumn, ...sortableColumns] : sortableColumns;

  return finalColumnMeta.map(({ propertyName, valueType }) => {
    const fieldConfig = defaultVisibleFields?.find(
      (f) => f.field === propertyName
    );

    const isVisible = Boolean(fieldConfig);

    return {
      field: propertyName,
      width: fieldConfig?.width || 200,
      minWidth: 120,
      hide: !isVisible,
      editable: true,
      headerAlign: 'center',
      align: 'center',

      renderHeader: () => (
        <Typography fontSize="0.875rem" fontWeight="bolder">
          {propertyName === 'name' ? 'Name' : propertyName.split('.').pop()}
          <span style={{ fontSize: 12, fontWeight: 200, display: !valueType && 'none' }}>
            {' '} ({valueType})
          </span>
        </Typography>
      ),

      renderCell,
      renderEditCell
    };
  });
};
